var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:['m0 lh0', {'center': _vm.horizontal}]},_vm._l((_vm.symmetries),function(sym,i){return _c('li',{key:i,staticClass:"symmetry-type",class:[sym, {'inline-block': _vm.horizontal}],attrs:{"role":"img"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }